<template>
  <div v-if="pageDevice != null && isLoginUserPageItemWritable">

    <deviceTabs :current="'log'" :pageDevice="pageDevice" :pageUser="pageUser" />

    <div class="m-0 mt-3 mr-2" v-if="this.pageDevice.disabled == true">
      <b-alert class="m-0 mt-2 mb-2 p-1 pl-2 fontSizeDot9" show variant="danger">
        정지 중이므로 기기의 인증코드를 설정할 수 없습니다.
      </b-alert>
    </div>

    <p class="mt-2 pt-0 gothic">
      업로드 데이터를 받았는 데 저장하는 중에 에러가 난 경우에 최대 10개까지 로그 기록을 남깁니다. 로그 기록은 기기 조회가 성공한 이후에 발생한 에러만 로그로 납깁니다. 기기를 생성하거나 센서를 추가하는 등의 중요한 작업을 한 경우에도 로그로 남깁니다.
    </p>

    <div class="m-2">
      <b-table v-touch:swipe.stop striped bordered hover :fields="gridFields" :items="this.pageDevice.logs" class="logGrid">
      </b-table>
    </div>

    <div class="text-right mr-2 mt-2">
      <b-button type="button" size="sm" @click="removeLogs" variant="danger" :disabled="!this.pageBinded">
        <b-spinner small type="grow" class="mr-1" v-if="this.showRemoveSpinner"></b-spinner>
        로그 모두 지우기
      </b-button>
    </div>
  </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { db } from "@/plugins/firebase.js"

import uiUtil from "@/mixins/util.js"
import mapUtil from "@/mixins/mapUtil.js"
import user from "@/mixins/user.js"
import functions from "@/mixins/functions.js"

import deviceTabs from "@/components/device/deviceTabs.vue"

export default {
  name: "deviceLog",
  mixins: [uiUtil, mapUtil, user, functions],
  props: {
    pageUser: Object,
    pageDevice: Object,
    pageBinded: Boolean,
  },
  components: {
    deviceTabs,
  },
  data: function() {
    return {
      gridFields: [
        {
          key: "dt",
          label: '생성일시',
          sortable: true,
          formatter: value => {
            return this.toISOStringWithoutZone(value.toDate())
          }
        },
        {
          key: "message",
          label: '내용',
          sortable: true,
          tdClass: "contentTd"
        },
        {
          key: "from",
          label: '위치',
          sortable: true,
        },
        {
          key: "level",
          label: '레벨',
          sortable: true,
        }
      ],
      showRemoveSpinner: false,
    }
  },
  created: function() {
    firebase.auth().onAuthStateChanged(() => {
      // if(firebase.auth().currentUser != null) { }
    })
  },
  methods: {
    removeLogs: function() {
      this.showRemoveSpinner = true
      db.collection("devices").doc(this.pageDevice.id).update({
        logs : [],
        "lastModified": firebase.firestore.FieldValue.serverTimestamp()
      })
      .then(()=> {
        this.showRemoveSpinner = false;
        this.makeToast("success", "로그 삭제 성공", "로그를 모두 지웠습니다.");
      })
      .catch(error => {
        this.showRemoveSpinner = false;
        this.makeToast("danger", "로그 삭제 실패", "로그를 지우는 중에 에러가 발생했습니다. 에러: " + error);
      })
    }
  },
}
</script>
